import { takeEvery, put, call, takeLatest } from "redux-saga/effects";
import {
  FETCH_HOLIDAYS,
  CREATE_HOLIDAY,
  UPDATE_HOLIDAY,
  DELETE_HOLIDAY,
  FETCH_HOLIDAY_EMPLOYEE_SUCCESS,
  FETCH_HOLIDAY_EMPLOYEE_FAILURE,
  SAVE_HOLIDAY_PROCESS_SUCCESS,
  SAVE_HOLIDAY_PROCESS_FAILURE,
  REMOVE_EMPLOYEE_HOLIDAY_SUCCESS,
  REMOVE_EMPLOYEE_HOLIDAY_FAILURE,
  FETCH_HOLIDAY_EMPLOYEE,
  SAVE_HOLIDAY_PROCESS,
  REMOVE_EMPLOYEE_HOLIDAY,
  FETCH_HOLIDAY_PROCESS_LIST_REQUEST
} from "./actionTypes";
import {
  fetchHolidaysSuccess,
  fetchHolidaysFailure,
  createHolidaySuccess,
  createHolidayFailure,
  updateHolidaySuccess,
  updateHolidayFailure,
  deleteHolidaySuccess,
  deleteHolidayFailure,
  fetchHolidays,
  fetchHolidayProcessListFailure,
  fetchHolidayProcessListSuccess
} from "./actions";
import { get, post, update, del } from "../../../helpers/api_helper"; // Adjust API helper path
import Swal from "sweetalert2";

// const API_URL = "/holidays";

// Fetch Holidays
function* fetchHolidaysSaga(action) {
  try {
    const apiUrl = process.env.REACT_APP_GET_HOLIDAY_API;

    // Convert to FormData
    const formData = new FormData();
    formData.append("unit_id", action.payload.unitId);

    // Call API
    const response = yield call(post, apiUrl, formData);
    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to retrieve holiday!");
    }
    yield put(fetchHolidaysSuccess(response));

  } catch (error) {
    console.error("Saga API Error:", error);
    yield put(fetchHolidaysFailure(error.message));
  }
}

// Create Holiday
function* createHolidaySaga({ payload }) {
  try {
    const { formData } = payload;
    const apiUrl = process.env.REACT_APP_SAVE_HOLIDAY_API
    const response = yield call(post, apiUrl, formData);
    if (response?.status === "success") {
      Swal.fire({
        icon: "success",
        title: "Success",
        text: response.message || "Holiday saved successfully!",
      });
      yield put(createHolidaySuccess(response));
      const unitId = formData.get("unit_id");
      if (unitId) {
        yield put(fetchHolidays(unitId));
      } else {
        console.log("unit_id is missing in formData, fetch not triggered");
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: response.message || "Something went wrong!",
      });
      yield put(createHolidayFailure(response));
    }
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "API Error",
      text: error.message || "An error occurred while saving the holiday",
    });
    yield put(createHolidayFailure(error.message));
  }
}

// Update Holiday
function* updateHoliday({ payload }) {
  try {
    const response = yield call(update, `${API_URL}/${payload.id}`, payload);
    yield put(updateHolidaySuccess(response));
  } catch (error) {
    yield put(updateHolidayFailure(error.message));
  }
}

// Delete Holiday
function* deleteHoliday({ payload }) {
  try {
    yield call(del, `${API_URL}/${payload}`);
    yield put(deleteHolidaySuccess(payload));
  } catch (error) {
    yield put(deleteHolidayFailure(error.message));
  }
}

function* fetchHolidayEmployeeSaga({ payload }) {
  try {
    const response = yield call(post, process.env.REACT_APP_FETCH_HOLIDAY_EMPLOYEE_API, payload);
    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to fetch employee holidays");
    }

    yield put({ type: FETCH_HOLIDAY_EMPLOYEE_SUCCESS, payload: response });
  } catch (error) {
    console.error("fetchHolidayEmployeeSaga Error:", error);
     yield put({ type: FETCH_HOLIDAY_EMPLOYEE_FAILURE, error });
  }
}

// 🔹 2. Save Holiday Process
function* saveHolidayProcessSaga({ payload }) {
  try {
    const response = yield call(post, process.env.REACT_APP_SAVE_HOLIDAY_PROCESS_API, payload);
    if (response?.status === "success") {
      Swal.fire({
        icon: "success",
        title: "Success",
        text: response.message || "Holiday saved successfully!",
      });
      yield put({ type: SAVE_HOLIDAY_PROCESS_SUCCESS, payload: response });
    } else {
      throw new Error(response?.message || "Failed to save holiday process");
    }
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Error",
      text: error.message,
    });
    yield put({ type: SAVE_HOLIDAY_PROCESS_FAILURE, error });
  }
}

// 🔹 3. Remove Employee Holiday
function* removeEmployeeHolidaySaga({ payload }) {
  try {
    const response = yield call(post, process.env.REACT_APP_REMOVE_EMPLOYEE_HOLIDAY_API, payload);
    if (response?.status === "success") {
      Swal.fire({
        icon: "success",
        title: "Deleted",
        text: response.message || "Employee holiday removed!",
      });
      yield put({ type: REMOVE_EMPLOYEE_HOLIDAY_SUCCESS, payload: response });
    } else {
      throw new Error(response?.message || "Failed to remove holiday");
    }
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Error",
      text: error.message,
    });
    yield put({ type: REMOVE_EMPLOYEE_HOLIDAY_FAILURE, error });
  }
}

function* fetchHolidayProcessListSaga(action) {
  try {
    const formData = new FormData();
    formData.append('unit_id', action.payload.unit_id);

    const response = yield call(post, process.env.REACT_APP_FETCH_HOLIDAY_PROCESS, formData);

    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to fetch holiday process list!');
    }

    yield put(fetchHolidayProcessListSuccess(response));
  } catch (error) {
    console.error('Saga API Error:', error);
    yield put(fetchHolidayProcessListFailure(error.message));
  }
}

// Watcher Saga
function* holidaySaga() {
  yield takeEvery(FETCH_HOLIDAYS, fetchHolidaysSaga);
  yield takeEvery(CREATE_HOLIDAY, createHolidaySaga);
  yield takeEvery(UPDATE_HOLIDAY, updateHoliday);
  yield takeEvery(DELETE_HOLIDAY, deleteHoliday);

  yield takeLatest(FETCH_HOLIDAY_EMPLOYEE, fetchHolidayEmployeeSaga);
  yield takeLatest(SAVE_HOLIDAY_PROCESS, saveHolidayProcessSaga);
  yield takeLatest(REMOVE_EMPLOYEE_HOLIDAY, removeEmployeeHolidaySaga);

  yield takeLatest(FETCH_HOLIDAY_PROCESS_LIST_REQUEST, fetchHolidayProcessListSaga);
}

export default holidaySaga;
